import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_lve_web_price_strikethrough_alignment",
  stages: {
    default: 1,
    main_fd_with_discount: 2,
    users_reach_branded_fares_in_ddot: 3,
    ddot: 4,
    mdot: 5,
    solo: 6,
    non_solo: 7
  },
  defaultStage: 1,
  goals: {
    click_price_breakdown_in_fd: 1
  }
});

export default utils;
